import { useAuthentication } from '@/hooks/queries/authentication/useAuthentication';
import { isAuthorized } from '@/permissions';
import type { PolicyName } from '@/permissions/types';

// Reads the user from the authentication query — the same source the route guards use.
// (UserContext is never populated, so it can't be used for permission checks.)
export function usePermissions(): { isAllowed: (policyName: PolicyName, resource?: unknown) => boolean } {
  const { data: user } = useAuthentication();

  return {
    isAllowed: (policyName: PolicyName, resource?: unknown): boolean => {
      if (!user) return false;
      return isAuthorized({ perfil: user.perfil }, policyName, resource);
    },
  };
}
